import { number, object } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { Max32bitIntSchema } from '../max-32-bit-int.schema';

export const AwardPointsSchema = object({
  points: Max32bitIntSchema(number({ required_error: IS_REQUIRED }).min(1)),
});
